(() => {

  /* ================================
     HELPERS
  ================================= */

  const getTabFromUrl = () => {
    const params = new URLSearchParams(window.location.search);
    return params.get("tab");
  };

  const getHashFromUrl = () => {
    return window.location.hash?.replace("#", "") || null;
  };

  /* ================================
     CORE TAB FUNCTIONALITY
  ================================= */

  const setActiveContent = (section, blockId) => {
    const contentEls = section.querySelectorAll(".content-tabs__content");

    contentEls.forEach((el) => el.classList.remove("active"));

    const activeContent = section.querySelector(
      `[data-block-id="${blockId}"].content-tabs__content`
    );

    if (activeContent) {
      activeContent.classList.add("active");
    }
  };

  const scrollToHash = (section, hash) => {
    if (!hash) return;
    const target = section.querySelector(`#${hash}`);
    if (target) {
      setTimeout(() => {
        target.scrollIntoView({ behavior: "smooth", block: "start" });
      }, 150);
    }
  };

  const toggleTab = (section) => {
    const tabs = section.querySelectorAll(".content-tabs__tab");

    tabs.forEach((tab) => {
      const blockId = tab.dataset.blockId;
      const anchorId = tab.dataset.anchorId || null;

      // CLICK
      tab.addEventListener("click", () => {
        tabs.forEach((el) => el.classList.remove("active"));
        tab.classList.add("active");
        setActiveContent(section, blockId);

        const url = new URL(window.location);
        if (anchorId) {
          url.searchParams.delete("tab");
          url.hash = anchorId;
        } else {
          url.searchParams.set("tab", blockId);
          url.hash = "";
        }
        history.replaceState(null, null, url);
      });

      // KEYBOARD (ENTER)
      tab.addEventListener("keydown", (event) => {
        if (event.key === "Enter") {
          tabs.forEach((el) => el.classList.remove("active"));
          tab.classList.add("active");
          setActiveContent(section, blockId);

          const url = new URL(window.location);
          if (anchorId) {
            url.searchParams.delete("tab");
            url.hash = anchorId;
          } else {
            url.searchParams.set("tab", blockId);
            url.hash = "";
          }
          history.replaceState(null, null, url);
        }
      });
    });
  };

  /* ================================
     OPEN TAB FROM URL
  ================================= */

  const openTabFromUrl = (section) => {
    const tab = getTabFromUrl();
    const hash = getHashFromUrl();
    const tabOrHash = tab || hash;

    if (!tabOrHash) return;

    // Match op anchor ID (via hash) eerst, dan op block ID (via tab param) als fallback
    const targetTab =
      section.querySelector(`.content-tabs__tab[data-anchor-id="${tabOrHash}"]`) ||
      section.querySelector(`.content-tabs__tab[data-block-id="${tabOrHash}"]`);

    if (!targetTab) return;

    const tabs = section.querySelectorAll(".content-tabs__tab");
    tabs.forEach((el) => el.classList.remove("active"));
    targetTab.classList.add("active");

    const blockId = targetTab.dataset.blockId;
    setActiveContent(section, blockId);

    if (hash) {
      scrollToHash(section, hash);
    }
  };

  /* ================================
     COLLAPSIBLE LOGIC
  ================================= */

  const initCollapsibleBlock = (section) => {
    if (!section || !section.classList.contains("content-tabs-section")) return;

    const blocks = section.querySelectorAll(".content-tabs__collapsible");

    blocks.forEach((block) => {
      block.addEventListener("click", (event) => {
        const toggleEl = event.target.closest(
          ".content-tabs__collapsible-toggle"
        );
        if (!toggleEl) return;

        const contentEl = toggleEl.nextElementSibling;
        if (
          !contentEl ||
          !contentEl.classList.contains("content-tabs__collapsible-content")
        ) {
          return;
        }

        const isActive = toggleEl.classList.contains("active");

        if (!isActive) {
          slideDown(toggleEl, contentEl, 300);
        } else {
          slideUp(toggleEl, contentEl, 300);
        }
      });
    });
  };

  /* ================================
     INIT
  ================================= */

  const initSection = (section) => {
    if (!section || !section.classList.contains("content-tabs-section")) return;

    toggleTab(section);
    initCollapsibleBlock(section);

    // Delay ensures Shopify DOM is ready
    setTimeout(() => {
      openTabFromUrl(section);
    }, 50);
  };

  /* ================================
     INIT ALL SECTIONS
  ================================= */

  document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll(".content-tabs-section").forEach((section) => {
      initSection(section);
    });
  });

  /* ================================
     HANDLE BACK / FORWARD NAVIGATION
  ================================= */

  window.addEventListener("popstate", () => {
    document.querySelectorAll(".content-tabs-section").forEach((section) => {
      openTabFromUrl(section);
    });
  });

  /* ================================
     SHOPIFY EDITOR SUPPORT
  ================================= */

  document.addEventListener("shopify:section:load", function (event) {
    initSection(event.target);
  });

})();